<template>
  <div>
    <div v-for="(item,index) in list" :key="index">
      <!--選單按鈕-->
      <template v-if="item.type=='link' && (typeof item.enable === 'undefined' || item.enable)">
          <el-menu-item :index="item.index" @click="handleMenuSelected(item)">
            <i :class="item.icon"></i>
            <span slot="title">{{item.label}}</span>
          </el-menu-item>
      </template>
      <!--展開選單-->
      <template v-else-if="item.type=='submenu' && (typeof item.enable === 'undefined' || item.enable)">
          <el-submenu :index="item.index">
            <template slot="title">
                <i :class="item.icon"></i>
                <span slot="title" v-if="!isCollapse">{{item.label}}</span>
            </template>
            <SidebarMenuList
              :list="item.list"
              :isCollapse="isCollapse"
              @child-selected="handleMenuSelected">
            </SidebarMenuList>
          </el-submenu>
      </template>
      <!--群組-->
      <template v-else-if="item.type=='group' && (typeof item.enable === 'undefined' || item.enable)">
          <el-menu-item-group>
            <template slot="title">{{item.label}}</template>
            <SidebarMenuList
              :list="item.list"
              :isCollapse="isCollapse"
              @child-selected="handleMenuSelected">
            </SidebarMenuList>
          </el-menu-item-group>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ['list', 'isCollapse'],
  name: 'SidebarMenuList', // 遞迴呼叫自己
  data () {
    return {
    }
  },
  methods: {
    handleMenuSelected (item) {
      this.$emit('child-selected', item)
    }
  }
}
</script>

<style scope>
</style>
